const Colors = {
  white: '#fff',
  bgGray: '#EEEEEE',
};
export default Colors;
